export const ENV = process.env.REACT_APP_ENV || 'local';

export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY ?? '';
export const DATADOG_APPLICATION_ID = process.env.REACT_APP_DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL || '';
export const MOBILE_BASE_URL = process.env.REACT_APP_MOBILE_BASE_URL || '';
export const MONOLITH_BASE_URL = process.env.REACT_APP_PWCC_MONOLITH_URL || '';
